import styles from './index.module.scss'

export default function Contents() {
  return (
    <div className="content">
      <h1 className={styles.headers}>Contents</h1>
      <a href="/docs/quickstart">
          <strong>
              <p>Quick Start</p>
          </strong>
      </a>
      <a href="/docs/commands">
          <strong>
              <p>Commands</p>
          </strong>
      </a>
      <a href="/docs/configurations">
          <strong>
              <p>Configurations</p>
          </strong>
      </a>
      <a href="/docs/terms">
          <strong>
              <p>Terms of Services</p>
          </strong>
      </a>
      <a href="/docs/policy">
          <strong>
              <p className={styles.overflow}>Privacy Policy</p>
          </strong>
      </a>
  </div>
  )
}